import React, { Component } from 'react';
import { observer } from "mobx-react";
import { observable } from "mobx";

// buttons: 0=CANCEL, 1=OK, ...

@observer class NavModal extends Component {

  @observable visible = false;

  constructor(props, title) {
    super(props);

    this.title = this.props.title || title;
  }

  getButton(index, key) {
    switch(index) {
      case 0:
        return <button key={key} onClick={this.cancel.bind(this)}>Cancel</button>;
      case 1:
        return <button key={key} onClick={this.validate.bind(this)}>OK</button>
      default:
        return null;
    }
  }

  cancel() {
    if(this.props.onCancel)
      this.props.onCancel(this);
    this.visible = false;
  }

  validate() {
    if(this.props.onValidate)
      this.props.onValidate(this);
    this.visible = false;
  }

  getButtons() {
    return (this.props.buttons || [0, 1]).map((btnIndex, index) => {
      return this.getButton(btnIndex, index);
    })
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  getChild(index) {
    return this.refs['child-' + index];
  }

  render() {
    return (
      <div className="navModal" style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '50%',
        height: '40%',
        transform: 'translate(-50%, -50%)',
        visibility: this.visible ? "visible" : "hidden"
      }}>
        <div className="title">
          {this.title}
        </div>
        <div className="content">
          {React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
              key: index,
              ref: 'child-' + index
            })
          })}
          {this.onRender ? [this.onRender()].map((el, index) => {
            return React.cloneElement(el, {
              key: index,
              ref: 'child-' + index
            });
          }) : null}
        </div>
        <div className="buttons">
          {this.getButtons()}
        </div>
      </div>
    );
  }

}

export default NavModal;



// WEBPACK FOOTER //
// ./src/components/ui/nav/NavModal.js